import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import "../styles/NavBar.css";
import { useTranslation } from "react-i18next";
import {getChinesePath, getEnglishPath, getPath} from "../utils/functions";

function NavBar() {
  const [langDropdownOpen, setLangDropdownOpen] = useState(false);
  const langRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation(); // Correct destructuring
  const [partnersDropdownOpen, setPartnersDropdownOpen] = useState(false);


  useEffect(() => {
    const menuToggle = document.getElementById("menu-toggle");
    const mobileMenu = document.getElementById("mobileMenu");
    const menuClose = document.getElementById("menu-close");

    if (menuToggle && mobileMenu) {
      const toggleMenu = () => mobileMenu.classList.toggle("open");
      menuToggle.addEventListener("click", toggleMenu);

      if (menuClose) {
        menuClose.addEventListener("click", () => mobileMenu.classList.remove("open"));
      }

      const navLinks = mobileMenu.querySelectorAll("li:not(.partners-dropdown-mobile) .nav-link, .dropdown-link");
      navLinks.forEach(link => {
        link.addEventListener("click", () => mobileMenu.classList.remove("open"));
      });

      const handleDocClick = (event) => {
        if (
            mobileMenu.classList.contains("open") &&
            !mobileMenu.contains(event.target) &&
            !menuToggle.contains(event.target)
        ) {
          mobileMenu.classList.remove("open");
        }
      };
      document.addEventListener("click", handleDocClick);

      return () => {
        menuToggle.removeEventListener("click", toggleMenu);
        if (menuClose) {
          menuClose.removeEventListener("click", () => mobileMenu.classList.remove("open"));
        }
        mobileMenu.querySelectorAll(".nav-link, .dropdown-link").forEach(link => {
          link.removeEventListener("click", () => mobileMenu.classList.remove("open"));
        });
        document.removeEventListener("click", handleDocClick);
      };
    }
  }, []);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (langRef.current && !langRef.current.contains(event.target)) {
        setLangDropdownOpen(false);
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);

  const toggleLangDropdown = (e) => {
    e.stopPropagation();
    setLangDropdownOpen(!langDropdownOpen);
  };

  const togglePartnersDropdown = (e) => {
    e.preventDefault();
    setPartnersDropdownOpen(!partnersDropdownOpen);
  };

  const handleDownloadClick = (e) => {
    e.preventDefault();
    const homePath = getPath('/');
    const scrollToComingSoon = () => {
      const target = document.getElementById("coming-soon");
      if (target) {
        target.scrollIntoView({ behavior: "smooth" });
      }
    };
    if (location.pathname === homePath) {
      scrollToComingSoon();
    } else {
      navigate(homePath);
      setTimeout(scrollToComingSoon, 200);
    }
  };

  return (
      <nav className="first-container">
        <header className="d-flex flex-wrap justify-content-between align-items-center py-2 my-header">
          <a href={getPath('/')} className="d-flex align-items-center mb-3 mb-md-0 me-md-auto link-body-emphasis text-decoration-none logos">
            <img src="/Images/ActiviKid Cat (white).png" alt="ActiviKid Logo" className="logo-image" />
            <img src="/Images/font (white).png" alt="ActiviKid Logo" className="logo-font" />
          </a>
          <button id="menu-toggle" className="menu-btn d-lg-none" aria-label="Toggle navigation">
            <i className="bi bi-list menu-icon" />
          </button>

          <ul className="nav nav-pills d-none d-lg-flex align-items-center">
            <li className="nav-item">
              <a href={getPath('/about')} className="nav-link">{t('navbar.about')}</a>
            </li>
            <li className="nav-item">
              <a href={getPath('/blogs')} className="nav-link">{t('navbar.blog')}</a>
            </li>
            <li className="nav-item partners-dropdown">
              <span className="nav-link">{t('navbar.activikid_partners.title')}</span>
              <ul className="partners-dropdown-menu">
                <li>
                  <a href={getPath('/partners')} className="dropdown-link">
                    {t('navbar.activikid_partners.our_partners')}
                  </a>
                </li>
                <li>
                  <a href={getPath('/discover-more')} className="dropdown-link">
                    {t('navbar.activikid_partners.discover_more')}
                  </a>
                </li>
                <li>
                  <a href="https://partner.activikid.hk/partner-register" target="_blank" rel="noopener noreferrer" className="dropdown-link">
                    {t('navbar.activikid_partners.join_us')}
                  </a>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <a href={getPath('/plans')} className="nav-link">
                {t('navbar.plans')}
              </a>
            </li>
            <li className="nav-item">
              <a href={getPath('/faqs/general')} className="nav-link">{t('navbar.faqs')}</a>
            </li>
            <li className="nav-item">
              <a href="https://partner.activikid.hk/partner-login" target="_blank" rel="noopener noreferrer" className="partner-login-btn nav-link">
                {t('navbar.partner_login')}
              </a>
            </li>
            <li className="nav-item">
              <Link to={getPath('/')} onClick={handleDownloadClick} className="download-btn nav-link">
                {t('navbar.download')}
              </Link>
            </li>
            <li className="nav-item language-dropdown" ref={langRef}>
              <button className="lang-button" onClick={toggleLangDropdown} aria-label="Select Language">
                <i className="bi bi-globe" style={{ fontSize: "1.5rem" }} />
              </button>
              {langDropdownOpen && (
                  <ul className="lang-dropdown">
                    <li>
                      <Link to={getEnglishPath(location.pathname)} onClick={() => setLangDropdownOpen(false)}>
                        Eng
                      </Link>
                    </li>
                    <li>
                      <Link to={getChinesePath(location.pathname)} onClick={() => setLangDropdownOpen(false)}>
                        中文
                      </Link>
                    </li>
                  </ul>
              )}
            </li>
          </ul>
        </header>

        <div id="mobileMenu" className="mobile-menu d-lg-none">
          <div className="mobile-menu-header">
            <div className="mobile-menu-logo">
              <a href={getPath('/')} className="logos">
                <img src="/Images/ActiviKid Cat (dark blue).png" alt="ActiviKid Logo" className="logo-image" />
                <img src="/Images/font (dark blue).png" alt="ActiviKid Logo" className="logo-font" />
              </a>
            </div>
            <button id="menu-close" className="menu-close" aria-label="Close navigation">
              <i className="bi bi-x" style={{ fontSize: "1.5rem" }} />
            </button>
          </div>
          <div className="mobile-menu-buttons">
            <ul className="nav nav-pills flex-column">
              <li className="nav-item">
                <a href={getPath('/about')} className="nav-link">{t('navbar.about')}</a>
              </li>
              <li className="nav-item">
                <a href={getPath('/blogs')} className="nav-link">{t('navbar.blog')}</a>
              </li>
              <li className="nav-item partners-dropdown-mobile">
              <span className="nav-link" onClick={togglePartnersDropdown}>
                {t('navbar.activikid_partners.title')}
              </span>
                {partnersDropdownOpen && (
                    <ul className="partners-dropdown-mobile-menu">
                      <li>
                        <a href={getPath('/partners')} className="dropdown-link" onClick={() => setPartnersDropdownOpen(false)}>
                          {t('navbar.activikid_partners.our_partners')}
                        </a>
                      </li>
                      <li>
                        <a href={getPath('/discover-more')} className="dropdown-link" onClick={() => setPartnersDropdownOpen(false)}>
                          {t('navbar.activikid_partners.discover_more')}
                        </a>
                      </li>
                      <li>
                        <a href="https://partner.activikid.hk/partner-register" target="_blank" rel="noopener noreferrer" className="dropdown-link" onClick={() => setPartnersDropdownOpen(false)}>
                          {t('navbar.activikid_partners.join_us')}
                        </a>
                      </li>
                    </ul>
                )}
              </li>
              <li className="nav-item">
                <a href={getPath('/plans')} className="nav-link">
                  {t('navbar.plans')}
                </a>
              </li>
              <li className="nav-item">
                <a href={getPath('/faqs/general')} className="nav-link">{t('navbar.faqs')}</a>
              </li>
              <li className="nav-item">
                <a href="https://partner.activikid.hk/partner-login" target="_blank" rel="noopener noreferrer" className="partner-login-btn-mobile nav-link">
                  {t('navbar.partner_login')}
                </a>
              </li>
              <li className="nav-item">
                <Link to={getPath('/')} onClick={handleDownloadClick} className="download-btn-mobile nav-link">
                  {t('navbar.download')}
                </Link>
              </li>
            </ul>
            <div className="mobile-lang-wrapper">
              <button className="lang-button-mobile" onClick={toggleLangDropdown} aria-label="Select Language">
                <i className="bi bi-globe" style={{ fontSize: "1.5rem" }} />
              </button>
              {langDropdownOpen && (
                  <ul className="lang-dropdown-mobile">
                    <li>
                      <Link to={getEnglishPath(location.pathname)} onClick={() => setLangDropdownOpen(false)}>
                        Eng
                      </Link>
                    </li>
                    <li>
                      <Link to={getChinesePath(location.pathname)} onClick={() => setLangDropdownOpen(false)}>
                        中文
                      </Link>
                    </li>
                  </ul>
              )}
            </div>
          </div>
        </div>
      </nav>
  );
}

export default NavBar;